import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import Nav from 'react-bootstrap/Nav';


const Body = ({ purchaseorderReport, beginDate, endDate }) => {
    return (
        <div id="taxSummaryReport">
            {
                purchaseorderReport.list && purchaseorderReport.list.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    purchaseorderReport.list && purchaseorderReport.list.length > 0 &&
                    //If there's DATA
                    <div>
                        <div className="row m-0">
                            <div className="text-center list_header">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : ""}
                            </div>
                        </div>

                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" >
                            <div className="col-lg-12 title_summary">
                                <h3 className="m-0">SUMMARY</h3>
                            </div>{/* row - Date */}

                            <div className="row col-lg-12 mb-1">
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 border-right">
                                    <label>Total Value</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(purchaseorderReport.totalValue)}</h3>
                                </div>

                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 border-right text-right">
                                    <label className="sm_label">Total Tax</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(purchaseorderReport.totalTax)}</h3>
                                </div>

                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 border-right text-right">
                                    <label className="sm_label">Total Delivery Fee</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(purchaseorderReport.totalShipping)}</h3>
                                </div>

                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 border-right text-right">
                                    <label className="sm_label">Total Credit</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{purchaseorderReport.totalCredit}</h3>
                                </div>

                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 text-right">
                                    <label className="sm_label">Total Quantity</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{purchaseorderReport.totalQTY}</h3>
                                </div>
                            </div>
                        </div>
                        {
                            purchaseorderReport.list.map((item, index) => {

                                return (
                                    <div className="row col-lg-12 mb-1 no-gutters">
                                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-2 border-right">
                                        <label>PO#</label>
                                        <h3 className="m-0 size_1-3vmax">
                                            <Nav.Link className="edit-link" href={`/purchaseOrder/edit/${item.poNumber}/${item.branchId}`}>{item.poNumber}</Nav.Link>
                                        </h3>
                                    </div>
                                
                                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-2 border-right">
                                        <label>Quantity</label>
                                        <h3 className="m-0 size_1-3vmax">{item.itemQty}</h3>
                                    </div>
                                
                                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-2 border-right text-center">
                                        <label>Vendor</label>
                                        <h3 className="m-0 grey-text size_1-3vmax">{item.vendorName}</h3>
                                    </div>
                                
                                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-2 border-right text-center">
                                        <label>Value</label>
                                        <h3 className="m-0 grey-text size_1-3vmax">{getDollarFormat(item.itemValues)}</h3>
                                    </div>
                                
                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 border-right text-center mt-2_xs">
                                        <label>Delivery Fee</label>
                                        <h3 className="m-0 grey-text size_1-3vmax">{getDollarFormat(item.shippingCost)}</h3>
                                    </div>
                                
                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 border-right text-center mt-2_xs">
                                        <label>Tax</label>
                                        <h3 className="m-0 grey-text size_1-3vmax">{getDollarFormat(item.tax)}</h3>
                                    </div>
                                
                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center mt-2_xs">
                                        <label>Credits</label>
                                        <h3 className="m-0 grey-text size_1-3vmax">{item.credit}</h3>
                                    </div>
                                    
                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center mt-2_xs">
                                        <label>Supplier Invoice Number</label>
                                        <h3 className="m-0 grey-text size_1-3vmax">{item.supplierInvoiceNumber}</h3>
                                    </div>
                                </div>
                                );
                            })
                        }
                        {/*</CardSimple>
                </div>*/}

                    </div>
            }
        </div>
    );
};

export default Body;